module.exports = __webpack_public_path__ + "SI.png?ff4013bd78066076bf04917187f6adaa";